var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6179 12.3753C22.7012 11.9781 22.7454 11.5678 22.7454 11.1495C22.7503 7.18547 19.005 4.2857 15.1886 5.33588L4.96094 8.14945L10.0804 16.598L19.901 13.8968C20.0314 13.8608 20.1628 13.8307 20.2957 13.8066C19.7121 14.5963 18.8804 15.1683 17.9334 15.4315L7.11631 18.4306L12.2348 26.8791L22.6502 23.9904C25.2484 23.2692 27.0409 20.893 27.0409 18.1889C27.0448 16.8693 26.6138 15.5854 25.8144 14.5349C25.015 13.4842 23.892 12.7254 22.6179 12.3753ZM21.1755 11.1466C21.1804 8.20063 18.4047 6.07616 15.6044 6.84643L7.3777 9.11037L10.8087 14.7725L19.4841 12.3853C19.9966 12.2435 20.5257 12.1707 21.0574 12.1686C21.1343 11.8386 21.1755 11.4976 21.1755 11.1466ZM20.5527 15.7971C19.9078 16.3274 19.159 16.7171 18.3542 16.9411L9.53014 19.3875L12.9621 25.0506L22.2304 22.4798C23.1656 22.2165 23.9891 21.6543 24.5746 20.8795C25.1602 20.1046 25.4755 19.1596 25.4726 18.1889C25.4765 17.1944 25.1464 16.2275 24.5344 15.4429C23.9228 14.6583 23.0651 14.1014 22.0985 13.8617C21.7243 14.6075 21.1976 15.2668 20.5527 15.7971Z",
    fill: "#FF474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfc);
export default __webpack_public_path__ + "static/media/bfc.d04e8f7a4e74ddefae67b63d23c257ea.svg";
export { ForwardRef as ReactComponent };